module.exports = {
  'header': {
    'list': [
      {
        'id': '1',
        'title': '行业应用',
        'children': {
          'list': [
            {
              'id': '1-1',
              'parentMenuId': '1',
              'state': 'ICON',
              'name': 'Oil',
              'alias': '石油',
              'link': '/oil',
              'icon': '/static/images/index/1.png',
              'discription': '石油'
            },
            // {
            //   'id': '1-2',
            //   'parentMenuId': '1',
            //   'state': 'ICON',
            //   'name': 'Police',
            //   'alias': '警务',
            //   'link': '/police',
            //   'icon': '/static/images/index/2.png',
            //   'discription': '警务'
            // },
            {
              'id': '1-3',
              'parentMenuId': '1',
              'state': 'ICON',
              'name': 'Forestry',
              'alias': '林草',
              'link': '/forestry',
              'icon': '/static/images/index/3.png',
              'discription': '林草'
            },
            {
              'id': '1-4',
              'parentMenuId': '1',
              'state': 'ICON',
              'name': 'Water',
              'alias': '应急',
              'link': '/water',
              'icon': '/static/images/index/4.png',
              'discription': '应急'
            },
            {
              'id': '1-5',
              'parentMenuId': '1',
              'state': 'ICON',
              'name': 'Eletricity',
              'alias': '电力',
              'link': '/eletricity',
              'icon': '/static/images/index/5.png',
              'discription': '电力'
            },
            {
              'id': '1-6',
              'parentMenuId': '1',
              'state': 'ICON',
              'name': 'Recycle',
              'alias': '环保',
              'link': '/recycle',
              'icon': '/static/images/index/6.png',
              'discription': '环保'
            },
            {
              'id': '1-7',
              'parentMenuId': '1',
              'state': 'ICON',
              'name': 'Admiralty',
              'alias': '海事',
              'link': '/admiralty',
              'icon': '/static/images/index/7.png',
              'discription': '海事'
            }
          ]
        }
      },
      {
        'id': '2',
        'title': '行业产品',
        'children': {
          'list': [
            {
              'id': '2-1',
              'leaf': 2,
              'state': 'SORT',
              'title': '工业整机',
              'bg': '/static/images/header/industrial_merlin.png',
              'children': [
                {
                  'title': '灵隼系列无人机',
                  'list': [
                    {
                      'id': '2-1-1',
                      'parentMenuId': '2-1',
                      'name': '3VS composite wing uavs',
                      'alias': 'ZT-3VS',
                      'link': '/zt3vs',
                      'img': '/static/images/header/industrial_3v.png',
                      'discription': 'ZT-3VS复合翼无人机'
                    },
                    {
                      'id': '2-1-2',
                      'parentMenuId': '2-1',
                      'name': '16V composite wing uavs',
                      'alias': 'ZT-16V',
                      'link': '/zt16v',
                      'img': '/static/images/header/industrial_16v.png',
                      'discription': 'ZT-16V复合翼无人机'
                    },
                    // {
                    //   'id': '2-1-3',
                    //   'parentMenuId': '2-1',
                    //   'name': '21V composite wing uavs',
                    //   'alias': 'ZT-21V',
                    //   'link': '/zt21v',
                    //   'img': '/static/images/header/industrial_21v.png',
                    //   'discription': 'ZT-21V复合翼无人机'
                    // },
                    {
                      'id': '2-1-4',
                      'parentMenuId': '2-1',
                      'name': '25v fixed wing uavs',
                      'alias': 'ZT-25V',
                      'link': '/zt25v',
                      'img': '/static/images/header/industrial_25v.png',
                      'discription': 'ZT-25V固定翼无人机'
                    },
                    {
                      'id': '2-1-5',
                      'parentMenuId': '2-1',
                      'name': '39v composite wing uavs',
                      'alias': 'ZT-39V',
                      'link': '/zt39v',
                      'img': '/static/images/header/industrial_39v.png',
                      'discription': 'ZT-39V复合翼无人机'
                    },
                    {
                      'id': '2-1-6',
                      'parentMenuId': '2-1',
                      'name': '415m composite wing uavs',
                      'alias': 'ZT-415M',
                      'link': '/zt415m',
                      'img': '/static/images/header/industrial_39v.png',
                      'discription': 'ZT-415M无人机'
                    },
                    {
                      'id': '2-1-6',
                      'parentMenuId': '2-1',
                      'name': '415m composite wing uavs',
                      'alias': 'ZT-X405',
                      'link': '/ztx405',
                      'img': '/static/images/header/industrial_39v.png',
                      'discription': 'ZT-X405无人机'
                    },
                    {
                      'id': '2-1-6',
                      'parentMenuId': '2-1',
                      'name': '415m composite wing uavs',
                      'alias': 'ZT-11V',
                      'link': '/zt11v',
                      'img': '/static/images/header/industrial_39v.png',
                      'discription': 'ZT-11V无人机'
                    },
                    {
                      'id': '2-1-6',
                      'parentMenuId': '2-1',
                      'name': '415m composite wing uavs',
                      'alias': 'ZT-015X',
                      'link': '/zt015x',
                      'img': '/static/images/header/industrial_39v.png',
                      'discription': 'ZT-015X无人机'
                    }
                  ]
                },
                {
                  'title': '配套/拓展软件',
                  'list': [
                    {
                      'id': '2-1-4',
                      'parentMenuId': '2-1',
                      'name': 'yuanduyunxunyingwen',
                      'alias': '远度云巡无人机管理平台',
                      'link': '/admin',
                      'img': '',
                      'discription': '远度云巡无人机管理平台'
                    },
                    {
                      'id': '2-1-5',
                      'parentMenuId': '2-1',
                      'name': 'fangzhenfeixingyingwen',
                      'alias': '仿真飞行培训套件',
                      'link': '/simulation',
                      'img': '',
                      'discription': '仿真飞行培训套件'
                    },
                    {
                      'id': '2-1-6',
                      'parentMenuId': '2-1',
                      'name': 'taishiyingwen',
                      'alias': '态势视频/图实时生成软件',
                      'link': '/situation',
                      'img': '',
                      'discription': '态势视频/图实时生成软件'
                    }
                  ]
                }
              ]
            },
            {
              'id': '2-2',
              'leaf': 1,
              'state': 'SORT',
              'title': '航电系统',
              'bg': '/static/images/header/industrial_merlin.png',
              'children': [
                {
                  'id': '2-2-1',
                  'parentMenuId': '2-2',
                  'name': 'Polaris',
                  'alias': '自驾仪',
                  'link': '/polaris',
                  'img': '/static/images/header/avionics_polaris.png',
                  'discription': '自驾仪'
                },
                {
                  'id': '2-2-2',
                  'parentMenuId': '2-2',
                  'name': 'Digital',
                  'alias': '数图一体数据链',
                  'link': '/digital',
                  'img': '/static/images/header/avionics_digital.png',
                  'discription': '数图一体数据链'
                },
                {
                  'id': '2-2-3',
                  'parentMenuId': '2-2',
                  'name': 'Pod',
                  'alias': '光电吊舱',
                  'link': '/pod',
                  'img': '/static/images/header/avionics_pod.png',
                  'discription': '光电吊舱'
                }
                // {
                //   'id': '2-2-4',
                //   'parentMenuId': '2-2',
                //   'name': 'Visual',
                //   'alias': '智能视觉导航模块',
                //   'link': '/visual',
                //   'img': '/static/images/header/avionics_module.png',
                //   'discription': '智能视觉导航模块'
                // },
                // {
                //   'id': '2-2-5',
                //   'parentMenuId': '2-2',
                //   'name': 'PTZ',
                //   'alias': '云台',
                //   'link': '/PTZ',
                //   'img': '/static/images/header/avionics_PTZ.png',
                //   'discription': '云台'
                // }
              ]
            }
          ]
        }
      },
      {
        'id': '7',
        'title': '航电系统',
        'children': {
          'list': [
            {
              'id': '7-1',
              'parentMenuId': '7',
              'state': 'ICON',
              'name': 'Pilot',
              'alias': 'ZT-Pilot⻜控系统',
              'link': '/pilot',
              'icon': '/static/images/index/1.png',
              'discription': 'ZT-Pilot⻜控系统'
            },
            {
              'id': '7-2',
              'parentMenuId': '7',
              'state': 'ICON',
              'name': 'Link',
              'alias': 'ZT-Link数据链',
              'link': '/link',
              'icon': '/static/images/index/2.png',
              'discription': 'ZT-Link数据链'
            },
            {
              'id': '7-3',
              'parentMenuId': '7',
              'state': 'ICON',
              'name': 'Gimbal',
              'alias': 'ZT-Gimbal光电吊舱',
              'link': '/gimbal',
              'icon': '/static/images/index/3.png',
              'discription': 'ZT-Gimbal光电吊舱'
            },
            {
              'id': '7-4',
              'parentMenuId': '7',
              'state': 'ICON',
              'name': 'GimbalSpecial',
              'alias': 'ZT-Gimbal特种吊舱',
              'link': '/gimbal-special',
              'icon': '/static/images/index/4.png',
              'discription': 'ZT-Gimbal特种吊舱'
            }
            // {
            //   'id': '7-5',
            //   'parentMenuId': '7',
            //   'state': 'ICON',
            //   'name': 'Solution',
            //   'alias': '⾼阶解决⽅案',
            //   'link': '/gimbal-special',
            //   'icon': '/static/images/index/5.png',
            //   'discription': '⾼阶解决⽅案'
            // }
          ]
        }
      },
      // {
      //   'id': '3',
      //   'title': '编队表演',
      //   'target': 'self',
      //   'link': '/formation'
      // },

      {
        'id': '4',
        'title': '动态资讯',
        'target': 'self',
        'link': '/news/official'
      },
      {
        'title': '走进远度',
        'id': '5',
        'children': {
          'isHv': 0,
          'list': [
            {
              'id': '5-2',
              'parentMenuId': '5',
              'state': 'TEXT',
              'name': 'After Sales',
              'alias': '关于我们',
              'link': '/about-us',
              'discription': '企业介绍'
            },
            {
              'id': '5-1',
              'parentMenuId': '5',
              'state': 'TEXT',
              'name': 'About',
              'alias': '公司简介',
              'link': '/company',
              'discription': '公司简介'
            },
            {
              'id': '5-3',
              'parentMenuId': '5',
              'state': 'TEXT',
              'name': 'Contact Us',
              'alias': '联系我们',
              'link': '/contact-us',
              'discription': '联系我们'
            },
            {
              'id': '6-3',
              'parentMenuId': '6',
              'state': 'TEXT',
              'name': 'statement',
              'alias': '合规管理',
              'link': '/statement',
              'discription': '合规管理'
            },
          ]
        }
      },
      {
        'id': '6',
        'title': '加入我们',
        'target': 'self',
        'link': '/join-us'
      },
      // {
      //   'id': '9',
      //   'title': '声明',
      //   'target': 'self',
      //   'link': '/jstatement'
      // },

    ],
    'listM': [
      {
        'title': '行业应用',
        'id': '1',
        'children': {
          'isHv': 0,
          'list': [
            {
              'id': '1-1',
              'parentMenuId': '1',
              'state': 'ICON',
              'name': 'Oil',
              'alias': '石油',
              'link': '/oil',
              'icon': '/static/images/header/icon_oil.png',
              'discription': '石油'
            },
            // {
            //   'id': '1-2',
            //   'parentMenuId': '1',
            //   'state': 'ICON',
            //   'name': 'Police',
            //   'alias': '警务',
            //   'link': '/police',
            //   'icon': '/static/images/header/icon_police.png',
            //   'discription': '警务'
            // },
            {
              'id': '1-3',
              'parentMenuId': '1',
              'state': 'ICON',
              'name': 'Forestry',
              'alias': '林草',
              'link': '/forestry',
              'icon': '/static/images/header/icon_forestry.png',
              'discription': '林草'
            },
            {
              'id': '1-4',
              'parentMenuId': '1',
              'state': 'ICON',
              'name': 'Water',
              'alias': '应急',
              'link': '/water',
              'icon': '/static/images/header/icon_water.png',
              'discription': '应急'
            },
            {
              'id': '1-5',
              'parentMenuId': '1',
              'state': 'ICON',
              'name': 'Eletricity',
              'alias': '电力',
              'link': '/eletricity',
              'icon': '/static/images/header/icon_electricity.png',
              'discription': '电力'
            },
            {
              'id': '1-6',
              'parentMenuId': '1',
              'state': 'ICON',
              'name': 'Recycle',
              'alias': '环保',
              'link': '/recycle',
              'icon': '/static/images/header/icon_recycle.png',
              'discription': '环保'
            },
            {
              'id': '1-7',
              'parentMenuId': '1',
              'state': 'ICON',
              'name': 'Admiralty',
              'alias': '海事',
              'link': '/admiralty',
              'icon': '/static/images/header/icon_admiralty.png',
              'discription': '海事'
            }
          ]
        }
      },
      {
        'title': '工业整机',
        'id': '2',
        'children': {
          'isHv': 0,
          'list': [
            {
              'title': '凌隼系列',
              'state': 'SORT',
              'list': [
                {
                  'id': '2-2',
                  'parentMenuId': '2',
                  'name': '3V composite wing uavs',
                  'alias': '3VS复合翼无人机',
                  'link': '/zt3vs',
                  'img': '/static/images/header/industrial_3v.png',
                  'discription': '3VS复合翼无人机'
                },
                {
                  'id': '2-1',
                  'parentMenuId': '2',
                  'name': '16V composite wing uavs',
                  'alias': 'ZT-16V复合翼无人机',
                  'link': '/zt16v',
                  'img': '/static/images/header/industrial_16v.png',
                  'discription': 'ZT-16V复合翼无人机'
                },
                // {
                //   'id': '2-3',
                //   'parentMenuId': '2',
                //   'name': '21V composite wing uavs',
                //   'alias': 'ZT-21V复合翼无人机',
                //   'link': '/zt21v',
                //   'img': '/static/images/header/industrial_21v.png',
                //   'discription': 'ZT-21V复合翼无人机'
                // },
                {
                  'id': '2-4',
                  'parentMenuId': '2',
                  'name': '39v composite wing uavs',
                  'alias': 'ZT-39V复合翼无人机',
                  'link': '/zt39v',
                  'img': '/static/images/header/industrial_39v.png',
                  'discription': 'ZT-39V复合翼无人机'
                },
                {
                  'id': '2-5',
                  'parentMenuId': '2',
                  'name': '25v fixed wing uavs',
                  'alias': 'ZT-25V复合翼无人机',
                  'link': '/zt25v',
                  'img': '/static/images/header/industrial_25v.png',
                  'discription': 'ZT-25V固定翼无人机'
                }
              ]
            },
            {
              'title': '软件系列',
              'state': 'SORT',
              'list': [
                {
                  'id': '2-4',
                  'parentMenuId': '2',
                  'name': 'yuanduyunxunyingwen',
                  'alias': '远度云巡无人机管理平台',
                  'link': '/admin',
                  'img': '',
                  'discription': '远度云巡无人机管理平台'
                },
                {
                  'id': '2-5',
                  'parentMenuId': '2',
                  'name': 'fangzhenfeixingyingwen',
                  'alias': '仿真飞行培训套件',
                  'link': '/simulation',
                  'img': '',
                  'discription': '仿真飞行培训套件'
                },
                {
                  'id': '2-6',
                  'parentMenuId': '2',
                  'name': 'taishiyingwen',
                  'alias': '态势视频/图实时生成软件',
                  'link': '/situation',
                  'img': '',
                  'discription': '态势视频/图实时生成软件'
                }
              ]
            }
          ]
        }
      },
      // {
      //   'title': '航电系统',
      //   'id': '3',
      //   'children': {
      //     'isHv': 0,
      //     'list': [
      //       {
      //         'id': '3-1',
      //         'parentMenuId': '3',
      //         'state': 'IMG',
      //         'name': 'Polaris',
      //         'alias': '自驾仪',
      //         'link': '/polaris',
      //         'img': '/static/images/header/avionics_polaris.png',
      //         'discription': '自驾仪'
      //       },
      //       {
      //         'id': '3-2',
      //         'parentMenuId': '3',
      //         'state': 'IMG',
      //         'name': 'Digital',
      //         'alias': '数图一体数据链',
      //         'link': '/digital',
      //         'img': '/static/images/header/avionics_digital.png',
      //         'discription': '数图一体数据链'
      //       },
      //       {
      //         'id': '3-3',
      //         'parentMenuId': '3',
      //         'state': 'IMG',
      //         'name': 'Pod',
      //         'alias': '光电吊舱',
      //         'link': '/pod',
      //         'img': '/static/images/header/avionics_pod.png',
      //         'discription': '光电吊舱'
      //       }
      //       // {
      //       //   'id': '3-4',
      //       //   'parentMenuId': '3',
      //       //   'state': 'IMG',
      //       //   'name': 'Visual',
      //       //   'alias': '智能视觉导航模块',
      //       //   'link': '/visual',
      //       //   'img': '/static/images/header/avionics_module.png',
      //       //   'discription': '智能视觉导航模块'
      //       // },
      //       // {
      //       //   'id': '3-5',
      //       //   'parentMenuId': '3',
      //       //   'state': 'IMG',
      //       //   'name': 'PTZ',
      //       //   'alias': '云台',
      //       //   'link': '/PTZ',
      //       //   'img': '/static/images/header/avionics_PTZ.png',
      //       //   'discription': '云台'
      //       // }
      //     ]
      //   }
      // },
      {
        'id': '3',
        'title': '航电系统',
        'children': {
          'list': [
            {
              'id': '3-1',
              'parentMenuId': '3',
              'state': 'ICON',
              'name': 'Pilot',
              'alias': 'ZT-Pilot⻜控系统',
              'link': '/pilot',
              'icon': '/static/images/index/1.png',
              'discription': 'ZT-Pilot⻜控系统'
            },
            {
              'id': '3-2',
              'parentMenuId': '3',
              'state': 'ICON',
              'name': 'Link',
              'alias': 'ZT-Link数据链',
              'link': '/link',
              'icon': '/static/images/index/2.png',
              'discription': 'ZT-Link数据链'
            },
            {
              'id': '3-3',
              'parentMenuId': '3',
              'state': 'ICON',
              'name': 'Gimbal',
              'alias': 'ZT-Gimbal光电吊舱',
              'link': '/gimbal',
              'icon': '/static/images/index/3.png',
              'discription': 'ZT-Gimbal光电吊舱'
            },
            {
              'id': '3-4',
              'parentMenuId': '3',
              'state': 'ICON',
              'name': 'GimbalSpecial',
              'alias': 'ZT-Gimbal特种吊舱',
              'link': '/gimbal-special',
              'icon': '/static/images/index/4.png',
              'discription': 'ZT-Gimbal特种吊舱'
            },
            {
              'id': '3-5',
              'parentMenuId': '3',
              'state': 'ICON',
              'name': 'Solution',
              'alias': '⾼阶解决⽅案',
              'link': '/solution',
              'icon': '/static/images/index/5.png',
              'discription': '⾼阶解决⽅案'
            }
          ]
        }
      },
      {
        'title': '编队表演',
        'id': '4',
        'link': '/formation'
      },
      {
        'title': '媒体中心',
        'id': '5',
        'children': {
          'isHv': 0,
          'list': [
            {
              'id': '5-1',
              'parentMenuId': '5',
              'state': 'TEXT',
              'name': 'Official',
              'alias': '公司新闻',
              'link': '/news/official',
              'discription': '公司新闻'
            },
            {
              'id': '5-2',
              'parentMenuId': '5',
              'state': 'TEXT',
              'name': 'Report',
              'alias': '媒体报道',
              'link': '/news/report',
              'discription': '媒体报道'
            }
          ]
        }
      },
      {
        'title': '走进远度',
        'id': '6',
        'children': {
          'isHv': 0,
          'list': [
            {
              'id': '5-1',
              'parentMenuId': '5',
              'state': 'TEXT',
              'name': 'About',
              'alias': '关于我们',
              'link': '/about-us',
              'discription': '企业介绍'
            },
            {
              'id': '5-2',
              'parentMenuId': '5',
              'state': 'TEXT',
              'name': 'Company',
              'alias': '公司简介',
              'link': '/company',
              'discription': '企业介绍'
            },
            {
              'id': '5-3',
              'parentMenuId': '5',
              'state': 'TEXT',
              'name': 'Contact Us',
              'alias': '联系我们',
              'link': '/contact-us',
              'discription': '联系我们'
            },{
              'id': '6-3',
              'parentMenuId': '6',
              'state': 'TEXT',
              'name': 'statement',
              'alias': '合规管理',
              'link': '/statement',
              'discription': '合规管理'
            }

          ]
        }
      },
      {
        'title': '加入我们',
        'id': '7',
        'children': {
          'isHv': 0,
          'list': [
            {
              'id': '6-1',
              'parentMenuId': '6',
              'state': 'TEXT',
              'name': 'Campus',
              'alias': '校园招聘',
              'link': '/campus',
              'discription': '校园招聘'
            },
            {
              'id': '6-2',
              'parentMenuId': '6',
              'state': 'TEXT',
              'name': 'Social',
              'alias': '社会招聘',
              'link': '/social',
              'discription': '社会招聘'
            }
          ]
        }
      }
    ],
    'assistInfo': {
      'lang': 'CN',
      'login': 'login',
      'register': 'register',
      'href': '/'
    }
  },
  'footer': [
    {
      'titleZH': '走进远度',
      'titleEN': 'Contact us',
      'children': [
        {
          'name': '关于我们',
          'target': 'self',
          'href': '/about-us'
        },
        {
          'name': '公司简介',
          'target': 'self',
          'href': '/company'
        },
        {
          'name': '联系我们',
          'target': 'self',
          'href': '/contact-us'
        },
        {
          'name': '合规管理',
          'target': 'self',
          'href': '/statement'
        }
      ]
    },
    {
      'titleZH': '技术支持',
      'titleEN': 'Support',
      'children': [
        {
          'name': '帮助与支持',
          'target': 'self',
          'href': '/after-sale'
        }
      ]
    },
    {
      'titleZH': '加入我们',
      'titleEN': 'Join us',
      'children': [
        {
          'name': '加入我们',
          'target': 'self',
          'href': '/join-us'
        },
        {
          'name': '社会招聘',
          'target': 'self',
          'href': '/social'
        },
        {
          'name': '校园招聘',
          'target': 'self',
          'href': '/campus'
        }
      ]
    },
    {
      'titleZH': '媒体中心',
      'titleEN': 'Media center',
      'children': [
        {
          'name': '公司新闻',
          'target': 'self',
          'href': '/news/official'
        },
        {
          'name': '媒体报道',
          'target': 'self',
          'href': '/news/report'
        }
      ]
    }
  ]
};



// WEBPACK FOOTER //
// ./src/i18n/lang/zh.js